module.exports = __webpack_public_path__ + "img/breizhInfo-logo.de4da480.png";